import {
  createMasterEvent,
  createStoreBuyer,
  getSingleBuyer,
  getSingleMasterEvent,
  handleKeyDown,
  updateBuyer,
  updateMasterEvent,
} from "_services";
import { CommonDate, CommonInput, CommonModal, CommonTextarea } from "components";
import { createEvent } from "features/masterService";
import { errorSchema, utils } from "helper";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../assets/css/modal.css";

const AddBuyerModal = (props) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    address: "",
  });
  const [initialForm, setInitialForm] = useState({
    name: "",
    phone: "",
    address: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const nameRef = useRef();
  const coupleRef = useRef();
  const addressRef = useRef();
  const [formError, setFormError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props?.addressId) {
      getEventDetails(props?.addressId);
    }
  }, [props?.addressId]);

  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.focus();
    }
  }, []);

  const getEventDetails = async (id) => {
    try {
      const res = await getSingleBuyer(id);

      if (res?.status === 200) {
        const eventData = {
          name: res.results.name,
          phone: res.results.phone,
          address: res.results.address,
        };
        setForm(eventData);
        setInitialForm(eventData);
      }
    } catch (error) {}
  };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.buyerSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  const handleSubmit = async () => {
    const validationResult = await utils?.checkFormError(
      form,
      errorSchema.buyerSchema
    );
    const payload = {};

    Object.keys(form).map((item, index) => {
      if (form[item] !== initialForm[item]) {
        payload[item] = form[item];
      }
    });

    if (validationResult === true) {
      try {
        setIsLoading(true);
        if (props?.addressId) {
          const res = await updateBuyer({
            payload,
            id: props?.addressId,
          });

          if (res.status === 200) {
            setIsLoading(false);
            toast.success(res.message);
            props?.closeModal();
            props?.callBack();
          } else {
            toast.error(res.error);
          }
        } else {
          const res = await createStoreBuyer(payload);
          if (res.status === 201) {
            setIsLoading(false);
            toast.success(res.message);
            props?.closeModal();
            props?.callBack();
          } else {
            toast.error(res.error);
          }
        }
      } catch (error) {
        setIsLoading(false);
      }
    } else {
      setFormError(validationResult);
    }
  };

  const objectBid = {
    ...props,
    onSubmit: handleSubmit,
    disabled: isLoading || props?.eventView,
    isLoadding: isLoading,
  };

  const handleKey = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextInputRef) {
        nextInputRef.current.focus();
      } else {
        handleSubmit(e);
      }
    } else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  return (
    <>
      <CommonModal {...objectBid}>
        <div className="_plcMod_body" style={{ padding: "20px" }}>
          <div className="flxInr">
            <div className="singleDiv">
              <CommonInput
                type="text"
                label="Name"
                placeholder="Enter Name"
                name="name"
                value={form?.name}
                onChange={({ target: { name, value } }) => {
                  handleOnChange(name, value);
                }}
                focus={!!formError?.name}
                error={formError.name}
                ref={nameRef}
                onKeyDown={(e) => handleKey(e, coupleRef)}
                disabled={props?.eventView}
              />
            </div>
            <div className="singleDiv">
              <CommonInput
                type="text"
                label="Phone"
                placeholder="Enter Phone Number"
                name="phone"
                value={form?.phone}
                onChange={({ target: { name, value } }) => {
                  handleOnChange(name, value);
                }}
                focus={!!formError?.name}
                error={formError.name}
                ref={coupleRef}
                onKeyDown={(e) => handleKey(e, addressRef)}
                disabled={props?.eventView}
                maxLength={10}
                onKeyPress={handleKeyDown}
                helpText="Phone Number Without +91"
              />
            </div>
            <div className="singleDiv">
              <CommonTextarea
                type="textarea"
                label="Address"
                name="address"
                value={form.address}
                focus={!!(typeof formError === "object" && formError?.address)}
                error={
                  !!(typeof formError === "object") ? formError?.address : ""
                }
                onChange={({ target: { name, value } }) =>
                  handleOnChange(name, value)
                }
                ref={addressRef}
                onKeyDown={(e) => handleKey(e, null)}
                disabled={props?.eventView}
              />
            </div>

            <div className="singleDiv"></div>
          </div>
        </div>
      </CommonModal>
      <div className="offBack_drop"></div>
    </>
  );
};

export default AddBuyerModal;
